import { PlainVersionedObject, VersionedObject } from '../../base/versioned-object';
import { CommonConnectionSettings } from './common-connection-settings';

/**
 * Defines The extension settings object for the connection. Each key identifies the settings for one extension
 */

export interface ExtensionConnectionSettingsMap extends MsftSme.StringMap<PlainVersionedObject> { }
/**
 * The Versioned representation of the Connection Settings.
 */
export class ConnectionSettings extends VersionedObject {

    /**
     * The names of properties that are saved into the versioned object
     */
    private static propertyNames = {
        common: 'common',
        extensions: 'extensions'
    };

    /**
     * Getter for the latest version of the user profile.
     */
    public get latestVersion(): number {
        return 1;
    }

    /**
     * Getter for common connection settings object
     * The settings in the object are available to all extensions
     */
    public get common(): CommonConnectionSettings {
        return new CommonConnectionSettings(
            <PlainVersionedObject>this.getProperty(ConnectionSettings.propertyNames.common),
            {
                save: (object) => {
                    return this.trySave(() => {
                        this.setProperty(ConnectionSettings.propertyNames.common, object);
                    });
                }
            }
        );
    }

    /**
     * Getter for extension connection settings object map
     * Each extension has its own object in this map.
     */
    public get extensions(): ExtensionConnectionSettingsMap {
        return <ExtensionConnectionSettingsMap>this.getProperty(ConnectionSettings.propertyNames.extensions);
    }

    /**
     * Setter for extension connection settings object map
     */
    public set extensions(value: ExtensionConnectionSettingsMap) {
        this.setProperty(ConnectionSettings.propertyNames.extensions, value);
    }

    /**
     * upgrades the current properties to the latest version
     * if this.currentVersion is null or undefined, then the upgrade should initialize to the latest version
     */
    protected upgrade() {
        // For now, we dont need to do anything but initialize to the latest version.
        // NOTE: When latestVersion is updated, then we need to add logic here to upgrade old connection settings objects.
        if (MsftSme.isNullOrUndefined(this.currentVersion)) {
            this.clear();
            this.setProperty(ConnectionSettings.propertyNames.common, <PlainVersionedObject>{ properties: {}, version: null });
            this.extensions = {};
            this.currentVersion = 0;
            return;
        } else if (this.currentVersion === 0) {
            // version 0 previously set common to {} which is incorrect for a versioned object.
            this.setProperty(ConnectionSettings.propertyNames.common, <PlainVersionedObject>{ properties: {}, version: null });
            this.currentVersion = 1;
        }
    }
}
